export enum RoomObjectApiEmbed {
    Shape = 'shape',
    Transform = 'transform'
}
